module.exports = __webpack_public_path__ + "img/fi-roundup-200x132.b0ef01fe.jpg";